import { AbstractContentState } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';
import { MarketingCard } from './utils';

export const MarketingCardContentSelector = (state: RootState): AbstractContentState<MarketingCard> =>
    state.content.marketingCard;
